import Vue from 'vue';
import { assign } from 'lodash';
import * as api from 'api/api-programs';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  ProgramDaySchedule: state => scheduleID => state[scheduleID],
};

const actions = {
  InitProgramDaySchedule({ commit }, params) {
    const scheduleID = params.scheduleID;
    commit(types.CLEAR_PROGRAM_DAY_SCHEDULES_STORE, { scheduleID });
  },
  GetProgramDaySchedule({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const dayID = params.dayID;
      const scheduleID = params.scheduleID;

      commit(types.FETCH_PROGRAM_DAY_SCHEDULE_START, { scheduleID });
      api.getSchedule(
        type,
        id,
        dayID,
        scheduleID,
        (response) => {
          commit(types.RECEIVE_PROGRAM_DAY_SCHEDULE, { scheduleID, response });
          resolve();
        },
        (description, status, error) => {
          if (status === 404) {
            commit(types.FETCH_PROGRAM_DAY_SCHEDULE_NOT_FOUND, { scheduleID, error });
            reject(error);
          } else {
            commit(types.FETCH_PROGRAM_DAY_SCHEDULE_ERROR, { scheduleID, error });
            reject(error);
          }
        },
      );
    });
  },
  ClearProgramDaySchedule({ commit }, { scheduleID }) {
    commit(types.CLEAR_PROGRAM_DAY_SCHEDULES_STORE, { scheduleID });
  },
};

const mutations = {
  [types.FETCH_PROGRAM_DAY_SCHEDULE_START](state, { scheduleID }) {
    if (state[scheduleID]) Vue.set(state, scheduleID, assign(state[scheduleID], neutralState, { fetching: true }));
    else Vue.set(state, scheduleID, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_PROGRAM_DAY_SCHEDULE_ERROR](state, { scheduleID, error }) {
    Vue.set(state, scheduleID, assign(state[scheduleID], neutralState, { error }));
  },
  [types.FETCH_PROGRAM_DAY_SCHEDULE_NOT_FOUND](state, { scheduleID }) {
    Vue.set(state, scheduleID, assign(state[scheduleID], neutralState, { notFound: true }));
  },
  [types.RECEIVE_PROGRAM_DAY_SCHEDULE](state, { scheduleID, response }) {
    Vue.set(state, scheduleID, assign(state[scheduleID], neutralState, { ready: true, meta: response.meta, data: response.data }));
  },
  [types.CLEAR_PROGRAM_DAY_SCHEDULES_STORE](state, { scheduleID }) {
    Vue.set(state, scheduleID, assign({}, initState));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/programs/entities/program-day-schedule.js